import { formatLabel, formatValue, isPlainObject } from '../format';
import { useTranslation } from 'react-i18next';
import '../Account.css';

type InfoListProps = {
    items: Array<{ key: string; value: unknown }>;
};

function flattenItems(items: Array<{ key: string; value: unknown }>) {
    return items.flatMap(({ key, value }) => {
        if (isPlainObject(value)) {
            return Object.entries(value).map(([childKey, childValue]) => ({
                key: key.toLowerCase() === 'balance' ? childKey : `${key} ${childKey}`,
                value: childValue,
            }));
        }

        return [{ key, value }];
    });
}

function InfoList({ items }: InfoListProps) {
    const { t } = useTranslation('account');
    const rows = flattenItems(items);

    if (!rows.length) {
        return <p className="account-empty">{t('empty.details')}</p>;
    }

    return (
        <dl className="account-list">
            {rows.map(({ key, value }) => (
                <div key={key} className="account-row">
                    <dt>{formatLabel(key)}</dt>
                    <dd>{Array.isArray(value) ? value.map(formatValue).join(', ') : formatValue(value)}</dd>
                </div>
            ))}
        </dl>
    );
}

export default InfoList;
